import axios from "axios";
import { BASE_URL, FAQ_URL } from "@/utils/api/Urls";

/**
 * Fetches FAQs from the server based on the provided search string.
 * @param search The search string to filter FAQs (optional).
 * @returns An array of FAQs matching the search criteria.
 */
export const fetchFAQs = async (search: string) => {
  const requestURL = search
    ? `${BASE_URL}${FAQ_URL}?SearchString=${search}`
    : `${BASE_URL}${FAQ_URL}`;

  try {
    const response = await axios.get(requestURL);
    return response.data as IFAQ[];
  } catch (err: unknown) {
    // Axios error
    if (axios.isAxiosError(err)) {
      // The request was made and the server responded with a status code
      if (err.response) {
        console.log("Error status:", err.response.status);
        return;
      }

      // The request was made but no response was received
      if (err.request) {
        console.log("No response received from server:", err.request);
        return;
      }
    }

    // Non-Axios error
    console.log("Non-Axios error occurred:", err);
  }
};
